import Vue from 'vue'

const template = {
  methods: {
    commandTemplate (e) {
      var vm = this
      return {
        template: Vue.component('temp', {
          template:
            `<div class="flex justify-center">
              <div class='text-center' v-if="ACTION.e">
                <a :href='url(templateArgs.id)' class='btn btn-warning btn-sm btn-editar' title='Editar' @click.prevent='buttonClick(templateArgs.id)'>
                  <i class='fa fa-pencil-square-o'></i> Editar
                </a>
              </div>
              <div class='text-center' v-if="ACTION.d">
                <a href='#' class='btn btn-danger btn-sm btn-apagar' title='Apagar' @click.prevent='buttonClickApagar(templateArgs)'>
                  <i class='fa fa-pencil-trash-o'></i> Apagar
                </a>
              </div>
            </div>`,
          data () {
            return {
              templateArgs: {}
            }
          },
          computed: {
            ACTION () {
              return vm.ACTION
            },
          },
          methods: {
            url (id) {
              return `${vm.url}${id}`
            },
            buttonClick (id) {
              vm.$router.push(`${vm.url}${id}`)
            },
            buttonClickApagar (item) {
              return vm.buttonClickApagar(item)
            }
          }
        }),
        templateArgs: e
      }
    }
  }
}

export default template
